<template>
  <div class="mock-header">
    <div class="top clearfix">
      <div class="logo">
        <a href="//www.jianshe99.com" target="_blank"></a>
      </div>
      <div class="title">机考模拟系统</div>
    </div>
    <div class="mini-header">
      <div class="con clearfix">
        <h2>{{ category }}</h2>
        <h3>{{ title }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
  import { category } from '@base/settings'

  export default {
    name: 'MockHeader',
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        category: category
      }
    }
  }
</script>
